/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./updateWebhook.defs.js";
export { main as default } from "./updateWebhook.defs.js";
